import { render, staticRenderFns } from "./CommentInspectionDateModal.vue?vue&type=template&id=885ca466&"
import script from "./CommentInspectionDateModal.vue?vue&type=script&lang=js&"
export * from "./CommentInspectionDateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports